import { IdentityPoolService } from '~src/authentication/services/IdentityPoolService';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { Messages } from '~src/codegen/Localize';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { serverUserAddToIdentityPool } from '~src/userManagement/users/actions/ServerUserMenuActions';
import { IServerUserInfo } from '~src/userManagement/users/models/IServerUserInfo';

export const ServerUserAddToIdentityPoolAction: IEntityAction<IServerUserInfo, {}> = {
  name: EntityActionNames.ServerUserAddToIdentityPool,
  translateName: Messages.identityPools_ServerUserAction_ServerUserAddToIdentityPool,
  isVisible: (_targetItems: IServerUserInfo[], _state: AppState) => {
    return FeatureFlags.identityPoolsEnabled && _targetItems.length === 1 &&
      IdentityPoolService.latestIdentityPools(true).length > _targetItems[0].poolMemberships?.length;
  },
  isClickable: (_availableActions: {}, targetItems: IServerUserInfo[], _state: AppState) => {
    return targetItems.length === 1;
  },
  createReduxAction: (targetItems: IServerUserInfo[]) => serverUserAddToIdentityPool(targetItems)
};
